import createReactClass from 'create-react-class';
import htmr from 'htmr';

//Uses htmr to parse HTML content, allowing for clickable links.

// NOTE:
// html-new is intended ONLY for static, trusted HTML.
// Do NOT pass user-generated or API-derived content here.
// If that changes, this component MUST be sanitized (e.g. DOMPurify).
export default function (dependencies) {
  const HTML = createReactClass({
    render() {
      var field = this.props.field;
      var apiStatus = field.state.api;
      var InputField = dependencies.InputField;
      return <div className="lz-input-wrapper">{htmr(field.state.value)}</div>;
    },
  });

  return {
    html: HTML,
    config: {
      ignored: true,
    },
  };
}
